/** 시간표 설정 섹션 최초 생성 시 기본 등록 색상(고정·전담·기초 제외) */
export const DEFAULT_SECTION_REGULAR_COLORS = ['#4e8d72', '#89b97e'] as const;
export const DEFAULT_SECTION_DEDICATED_COLORS = ['#d6c1bc', '#b6c8d3', '#d1c8d8'] as const;
export const DEFAULT_SECTION_BASE_EXCLUDE_COLORS = ['#ebb07e', '#f6d8a2', '#b7c297', '#a1d1c2'] as const;

/** @deprecated 레거시 DB·마이그레이션 판별용 */
export const LEGACY_DEFAULT_REGULAR_COLOR = '#2e7d32';

export function createDefaultGradeProgramColors(): {
  regular: string[];
  dedicated: string[];
  baseExclude: string[];
  project: string[];
  projectByTerm: { term1: string[]; term2: string[] };
} {
  return {
    regular: [...DEFAULT_SECTION_REGULAR_COLORS],
    dedicated: [...DEFAULT_SECTION_DEDICATED_COLORS],
    baseExclude: [...DEFAULT_SECTION_BASE_EXCLUDE_COLORS],
    project: [],
    projectByTerm: { term1: [], term2: [] },
  };
}

/** 고정 프로그램 색상표: 초록 계열 3색 */
export const REGULAR_PROGRAM_COLOR_PALETTE = [
  '#4a8b73',
  '#53a66e',
  '#8ebe84',
] as const;

/** 라벨링 색상표 (연간시간표/시간표설정 공통, 내부 키 baseExclude) */
export const BASE_EXCLUDE_COLOR_PALETTE = [
  '#f7c088',
  '#ffdfa4',
  '#d3c0a2',
  '#cbb3a9',
  '#cfcf99',
  '#a6dbc9',
  '#77c8bf',
  '#9ac0c9',
  '#93dce3',
  '#a9c4df',
  '#b0a8db',
  '#eab4ce',
] as const;

/** 프로젝트 색상표 (라벨링 색상과 독립, 동일 hex 사용 가능) */
export const PROJECT_PROGRAM_COLOR_PALETTE = [
  '#ff9b39',
  '#feb937',
  '#c39e6a',
  '#ae7967',
  '#b8b96d',
  '#67b29b',
  '#37978c',
  '#458899',
  '#39a1ae',
  '#6b91b5',
  '#8479b3',
  '#b47393',
] as const;
